import { Element, useEditor, useNode } from "@craftjs/core";
import { rem } from "polished";
import * as React from "react";
import type { AboutDetail } from "src/types";
import styled from "styled-components";

import TopLevelFloatingOptions from "@/components/editor/block-outline/floating-options/top-level-floating-component";
import Text from "@/components/editor/primitives/text/text-component";
import {
  BlockBackgroundColorWrapper,
  BlockMaxWidthWrapper,
  BlockPaddingWrapper,
} from "@/components/editor/shared/block-wrapper";

import AboutDetailsItem from "./about-details-item";
import AboutDetailsList from "./about-details-list-component";

type AboutDetailProps = {
  defaultDetails: AboutDetail[];
};
export default function AboutDetails(props: AboutDetailProps) {
  const {
    connectors: { connect },
    nodeId,
  } = useNode((node) => ({
    nodeId: node.id,
  }));

  const { enabled } = useEditor((state) => ({
    enabled: state.options.enabled,
  }));

  return (
    <BlockBackgroundColorWrapper ref={connect} id={nodeId}>
      <BlockPaddingWrapper>
        <BlockMaxWidthWrapper>
          <TitleWrapper>
            <Element
              id="about-details-title"
              is={Text}
              text="Look forward to..."
              element="h2"
              pattern="headingTwo"
            />
          </TitleWrapper>
          <Element
            id="about-details-list"
            is={AboutDetailsList}
            canvas={enabled}
          >
            {props.defaultDetails?.map((detail, index) => {
              return (
                <AboutDetailsItem
                  key={index}
                  data-testid="about-details-item"
                  paragraphHeading={detail.paragraphHeading}
                  paragraph={detail.paragraph}
                />
              );
            })}
          </Element>
        </BlockMaxWidthWrapper>
      </BlockPaddingWrapper>
    </BlockBackgroundColorWrapper>
  );
}

AboutDetails.craft = {
  custom: {
    displayName: "About Details",
  },
  related: {
    leftOutlineOptions: TopLevelFloatingOptions,
  },
};

const TitleWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: ${rem(40)};

  .headingTwo {
    margin: 0;
  }
`;
